import home from './home'

const views =
{
    home
};

export default views ;
